import Image from 'next/image'

const Support = ({t}) => {
  return (
    <>
    <h3 className='font-light text-[30px] md:text-[28px] my-12'>
      {t('support.title')}
    </h3>
    <p className='font-normal mb-6'>
      {t('support.chat-with-a-ROLZO-specialist')}
    </p>
    <p className='font-light leading-[1.5]'>
      {t.rich('support.chat-with-a-ROLZO-specialist-step-1', {
        bold: (chunks) => <span className='font-normal'>{chunks}</span>,
      })}
    </p>
    <p className='font-light mb-6'>
      {t.rich('support.chat-with-a-ROLZO-specialist-step-2', {
        bold: (chunks) => <span className='font-normal'>{chunks}</span>,
      })}
    </p>
    <div className='mb-12'>
      <Image priority={true}
        src='https://storage.googleapis.com/rolzo-static-bucket/images/website-updates/faq-chat-6.png'
        alt=''
        width={619}
        height={366}
        className='w-[75%] h-auto'
      />
    </div>
   
   
    <p className='font-normal mb-6'>
      {t('support.booking-from-quote-received-in-support-chat')}
    </p>
    <p className='font-light mb-6'>
      {t.rich('support.booking-from-quote-received-in-support-chat-step-1', {
        bold: (chunks) => <span className='font-normal'>{chunks}</span>,
      })}
    </p>
    <div className='mb-6'>
      <Image priority={true}
        src='https://storage.googleapis.com/rolzo-static-bucket/images/website-updates/faq-chat-quote-7.png'
        alt=''
        width={619}
        height={366}
        className='w-[75%] h-auto'
      />
    </div>
    <p className='font-light mb-6 leading-[1.5]'>
      {t('support.booking-from-quote-received-in-support-chat-step-2')}
    </p>
    <div className='mb-6'>
      <Image priority={true}
        src='https://storage.googleapis.com/rolzo-static-bucket/faq/image098.png'
        alt=''
        width={619}
        height={366}
        className='w-[75%] h-auto'
      />
    </div>
   
    <p className='font-light mb-6'>
      {t.rich('support.booking-from-quote-received-in-support-chat-step-3', {
        bold: (chunks) => <span className='font-normal'>{chunks}</span>,
      })}
    </p>
    <div className='mb-6'>
      <Image priority={true}
        src='https://storage.googleapis.com/rolzo-static-bucket/faq/image100.png'
        alt=''
        width={619}
        height={366}
        className='w-[75%] h-auto'
      />
    </div>
    <p className='font-light mb-6 leading-[1.5]'>
      {t('support.booking-from-quote-received-in-support-chat-step-4')}
    </p>
    <div className='mb-6'>
      <Image priority={true}
        src='https://storage.googleapis.com/rolzo-static-bucket/faq/image102.png'
        alt=''
        width={619}
        height={366}
        className='w-[75%] h-auto'
      />
    </div>
    <p className='font-light mb-6'>
      {t.rich('support.booking-from-quote-received-in-support-chat-step-5', {
        bold: (chunks) => <span className='font-normal'>{chunks}</span>,
      })}
    </p>
    <div className='mb-6'>
      <Image priority={true}
        src='https://storage.googleapis.com/rolzo-static-bucket/faq/image104.png'
        alt=''
        width={619}
        height={366}
        className='w-[75%] h-auto'
      />
    </div>
    </>
  )
}

export default Support